import { insertCharacter, setActiveTool } from "../../../commands/custom-commands";
import { validSpecialChars, validSpecialCharValues } from "../../../schemas/custom-schema";

export default class QuoteCharTool {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.originalView = editorView;
    this.buildContainer();
    this.buildDialog();
    this.bindActions();
    containerElement.appendChild(this.containerElement);
    this.update(editorView);
  }

  buildContainer() {
    this.containerElement = document.createElement("div");
    this.containerElement.className = "editor-button-container";
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.style.anchorName ="--char-anchor";
    this.buttonElement.dataset.action = "char";
    this.buttonElement.setAttribute("aria-expanded", "false");
    this.buttonElement.title = "Caracteres";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Caracteres";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Caracteres";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.containerElement.appendChild(this.buttonElement);
  }

  buildDialog() {
    const targetInputContainer = document.createElement("div"),
      targetLabel = document.createElement("label"),
      buttonsContainer = document.createElement("div");

    this.dialogElement = document.createElement("div");
    this.dialogElement.className = "editor-dialog";
    this.dialogElement.style.positionAnchor = "--char-anchor";
    this.typeInput = document.createElement("select");
    this.typeInput.className = "editor-dropdown";
    validSpecialChars.map(({ value, label }) => {
      const option = document.createElement("option");
      option.value = value;
      option.textContent = label;

      return option;
    }).forEach(option => this.typeInput.appendChild(option));

    this.submitButton = document.createElement("button");
    this.submitButton.type = "button";
    this.submitButton.className = "editor-button";
    this.submitButton.textContent = "Agregar";

    buttonsContainer.className = "editor-buttons-container";
    buttonsContainer.appendChild(this.submitButton);

    this.dialogElement.appendChild(this.typeInput);
    this.dialogElement.appendChild(buttonsContainer);

    this.containerElement.appendChild(this.dialogElement);
  }

  bindActions() {
    this.buttonAction = this.buttonClickCallback();
    this.submitAction = this.submitButtonClickCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.submitButton.addEventListener("click", this.submitAction);
  }

  update(view) {
    this.view = view;
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.submitButton.removeEventListener("submit", this.submitAction);
    this.containerElement.remove();
    this.containerElement = null;
    this.buttonElement = null;
    this.typeInput = null;
    this.submitButton = null;
    this.dialogElement = null;
    this.buttonAction = null;
    this.submitAction = null;
  }

  buttonClickCallback() {
    return () => {
      setActiveTool(this.buttonElement)(this.originalView.state, this.originalView.dispatch);
    }
  }

  submitButtonClickCallback() {
    return (event) => {
      event.preventDefault();
      const { value: type } = this.typeInput;

      if(!validSpecialChars.map(attrs => attrs.value).includes(type)) {
        return false;
      }

      insertCharacter(type)(this.view.state, this.view.dispatch, this.view);
      this.view.focus();
    }
  }
}
